import { Menu } from '@headlessui/react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';

export default function NavDropdown({ icon, title, items }) {
  const Icon = Icons[icon];

  return (
    <Menu as="div" className="relative group">
      <Menu.Button className="flex items-center w-full px-3 py-2.5 text-sm text-gray-600 hover:text-gray-900 group-hover:bg-gray-50">
        {Icon && <Icon size={18} className="mr-2" />}
        <span className="flex-1">{title}</span>
        <Icons.ChevronDown className="w-4 h-4 transition-transform duration-200 group-hover:rotate-180" />
      </Menu.Button>

      <Menu.Items className="absolute right-0 z-10 mt-1 w-56 origin-top-right bg-white rounded-lg shadow-lg ring-1 ring-black/5 focus:outline-none">
        <div className="py-1">
          {items.map((item, index) => {
            const ItemIcon = item.icon ? Icons[item.icon] : null;
            return (
              <Menu.Item key={index}>
                {({ active }) => (
                  <Link
                    to={item.to}
                    className={`flex items-center px-4 py-2 text-sm ${
                      active ? 'bg-gray-50 text-gray-900' : 'text-gray-600'
                    }`}
                  >
                    {ItemIcon && <ItemIcon size={16} className="mr-2" />}
                    {item.text}
                  </Link>
                )}
              </Menu.Item>
            );
          })}
        </div>
      </Menu.Items>
    </Menu>
  );
} 